export default () => ({
	legacy: false,
	fallbackLocale: "en",
	warnHtmlMessage: false
});
